import { render, staticRenderFns } from "./ResubmitEdit.vue?vue&type=template&id=7d25d570&"
import script from "./ResubmitEdit.vue?vue&type=script&lang=js&"
export * from "./ResubmitEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports